<template>
  <div class="home-main">
    <div class="home-body">
      <!-- 水量详情 -->
      <div class="item-box">
        <div class="model-title">
          <span class="txt">水量详情</span>
        </div>
        <div class="model-content">
          <div class="chart-box">
            <div class="chart-title">
              <p>
                年份：
                <el-date-picker
                  size="small"
                  v-model="chartYear"
                  type="year"
                  placeholder="选择年"
                  class="chart-picker"
                  @change="handleYear()"
                ></el-date-picker>
              </p>
              <div class="title-text">
                <p>
                  <span class="item-title">一季度：</span>
                  <span class="item-text item-plan">
                    计划量：
                    <i>{{aggregateYear.plan_first}}</i> m³
                  </span>
                  <span class="item-text item-use">
                    用水量：
                    <i>{{aggregateYear.water_first}}</i> m³
                  </span>
                  <span class="item-text item-rate">
                    占比：
                    <i
                      :style="{color: getRateColor(aggregateYear.average_first)}"
                    >{{aggregateYear.average_first}}</i> %
                  </span>
                </p>
                <p>
                  <span class="item-title">二季度：</span>
                  <span class="item-text item-plan">
                    计划量：
                    <i>{{aggregateYear.plan_second}}</i> m³
                  </span>
                  <span class="item-text item-use">
                    用水量：
                    <i>{{aggregateYear.water_second}}</i> m³
                  </span>
                  <span class="item-text item-rate">
                    占比：
                    <i
                      :style="{color: getRateColor(aggregateYear.average_second)}"
                    >{{aggregateYear.average_second}}</i> %
                  </span>
                </p>
                <p>
                  <span class="item-title">三季度：</span>
                  <span class="item-text item-plan">
                    计划量：
                    <i>{{aggregateYear.plan_third}}</i> m³
                  </span>
                  <span class="item-text item-use">
                    用水量：
                    <i>{{aggregateYear.water_third}}</i> m³
                  </span>
                  <span class="item-text item-rate">
                    占比：
                    <i
                      :style="{color: getRateColor(aggregateYear.average_third)}"
                    >{{aggregateYear.average_third}}</i> %
                  </span>
                </p>
                <p>
                  <span class="item-title">四季度：</span>
                  <span class="item-text item-plan">
                    计划量：
                    <i>{{aggregateYear.plan_four}}</i> m³
                  </span>
                  <span class="item-text item-use">
                    用水量：
                    <i>{{aggregateYear.water_four}}</i> m³
                  </span>
                  <span class="item-text item-rate">
                    占比：
                    <i
                      :style="{color: getRateColor(aggregateYear.average_four)}"
                    >{{aggregateYear.average_four}}</i> %
                  </span>
                </p>
              </div>
            </div>
            <div class="chart-body" id="aggregateYearFlow"></div>
          </div>
        </div>
      </div>
      <!-- 业务进度、通知通告 -->
      <div class="item-box-out">
        <!-- 业务进度 -->
        <div class="item-box">
          <div class="model-title">
            <span class="txt">业务进度</span>
            <div class="handle inline-block"><span class="btn" @click="handlerRefresh">刷新<i class="ico el-icon-refresh"></i></span></div>
          </div>
          <div class="model-content">
            <div class="circle-item">
              <p @click="handleplanstates">用水计划申报状态： <span>{{ planStatusTip }}</span></p>
              <p @click="handleHomeToolClick('overPlanManage')">待缴费记录：<i>{{billTableList.length}}</i></p>
              <div class="circle-view">
                <div
                  class="circle-cell"
                  v-for="e in WorkState"
                  :key="e.code"
                  @click="handlecell(e)"
                >
                  <div class="circle" :class="e.color">{{e.num}}</div>
                  <p class="txt">{{e.name}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 通知通告 -->
        <div class="item-box">
          <div class="model-title">
            <span class="txt">通知公告</span>
            <router-link class="link" to="/skjs/main/noticeQueryMessage">
              更多
              <i class="el-icon-d-arrow-right"></i>
            </router-link>
          </div>
          <div class="model-content">
            <div class="temporarily-data" v-if="noticeList.length === 0 && templateDataNotice.length === 0" >暂无数据内容</div>
            <!-- 通知列表 -->
            <div class="item-row pos" v-for="t in noticeList" :key="t.oid" @click="hanleNoticeRowClick(t)">
              <i class="ico iconfont">&#xe665;</i>
              {{t.notice_desc}}({{t.importance_text}})
              <span class="val">{{t.create_time}}</span>
            </div>
            <!-- 通知文件下载 -->
            <div class="item-row pos" v-for="e in templateDataNotice" :key="e.id+'file'">
              {{e.title}}
              <span
                class="val download"
                id="mydownload"
                @click="downloadNoticeFile(e)"
              >{{e.dec}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="item-box item-boxheight">
        <div class="model-title">
          <span class="txt">基本信息</span>
          <router-link class="link" to="/skjs/main/basicsQueryMessage">
            详情
            <i class="el-icon-d-arrow-right"></i>
          </router-link>
        </div>
        <div class="model-content">
          <div class="item-row flex">
            <div class="item-cell">
              <span class="cell-title inline-block">单位编码：</span>
              {{userInfo.code | filterValue}}
            </div>
            <div class="item-cell">
              <span class="cell-title inline-block">单位名称：</span>
              {{userInfo.name | filterValue}}
            </div>
          </div>
          <div class="item-row flex">
            <div class="item-cell">
              <span class="cell-title inline-block">联系人：</span>
              {{userInfo.contact_man | filterValue}}
            </div>
            <div class="item-cell">
              <span class="cell-title inline-block">联系电话：</span>
              {{userInfo.contact_phone | filterValue}}
            </div>
          </div>
          <div class="item-row flex">
            <div class="item-cell">
              <span class="cell-title inline-block">详细地址：</span>
              {{userInfo.addr_detail | filterValue}}
            </div>
            <div class="item-cell">
              <span class="cell-title inline-block">邮政编码：</span>
              {{userInfo.postal_code | filterValue}}
            </div>
          </div>
          <div class="item-row flex">
            <div class="item-cell">
              <span class="cell-title inline-block">是否为重点户：</span>
              {{userInfo.is_mainuser | filterValue('mainuser')}}
            </div>
            <div class="item-cell">
              <span class="cell-title inline-block">用水性质：</span>
              {{userInfo.usewater_id | filterValue}}
            </div>
          </div>
          <div class="item-row flex">
            <div class="item-cell">
              <span class="cell-title inline-block">用水单价：</span>
              {{userInfo.usewater_price | filterValue}}
            </div>
            <div class="item-cell">
              <span class="cell-title inline-block">绿化面积：</span>
              {{userInfo.green_area | filterValue}}
            </div>
          </div>
        </div>
      </div>
      <!-- 模板下载 -->
      <div class="item-box item-boxheight">
        <div class="model-title">
          <span class="txt">模板下载</span>
        </div>
        <div class="model-content">
          <div class="temporarily-data" v-if="templateData.length == 0">暂无数据内容</div>
          <div class="item-row pos" v-else v-for="e in templateData" :key="e.id">
            {{e.title}}
            <span class="val download" id="mydownload" @click="downloadhandle(e.title)">{{e.dec}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <div class="dialogform">
      <!-- 业务进度：球 -->
      <el-dialog
        v-if="dialog"
        :title="dialogtitle"
        :visible.sync="dialog"
        top="0"
        :width="dialigwidth"
        :before-close="handlecancel"
      >
        <!-- 表单 -->
        <el-form :inline="true" :model="formData" class="demo-form-inline" :rules="formDataRules">
          <el-form-item label="业务状态" prop="workstates">
            <el-select v-model="formData.workstates" clearable placeholder="请选择">
              <el-option
                v-for="item in WorkState_u"
                :key="item.value"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务类型" prop="worktypes">
            <el-select v-model="formData.worktypes" clearable placeholder="请选择">
              <el-option
                v-for="item in WorkType"
                :key="item.value"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onsearch" size="small">查询</el-button>
          </el-form-item>
        </el-form>
        <el-divider />
        <!-- 表格 -->
        <el-table
          ref="tableDataref"
          :data="tableData"
          highlight-current-row
          :fit="false"
          stripe
          height="500"
          border
          size="mini"
        >
          <el-table-column
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="#"
            type="index"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="user_code"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="计划户编码"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="user_name"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="计划户名称"
            width="220"
          ></el-table-column>
          <el-table-column
            prop="work_type"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="业务类型"
            width="140"
          >
            <template slot-scope="scope">
              <div v-for="(e, t) in WorkType" :key="t">
                <span v-if="scope.row.work_type === e.code">{{e.name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="work_status"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="业务进度"
            width="100"
          >
            <template slot-scope="scope">
              <div v-for="(e, t) in Work_States" :key="t">
                <span v-if="scope.row.work_status === e.code">{{e.name}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="work_desc"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="业务描述"
            width="260"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="创建时间"
            width="166"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="更新时间"
            width="166"
          ></el-table-column>
          <el-table-column
            prop="expire_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="截止办理时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="is_overtime"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="是否逾期未处理"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.is_overtime == 0">否</span>
              <span v-if="scope.row.is_overtime == 1">是</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                class="btn-marleft"
                type="primary"
                plain
                @click.native.prevent="handlebtns(scope.row)"
              >处理</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-divider />
        <!-- 分页器 -->
        <el-pagination
          class="page"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :background="true"
          layout="total, prev, pager, next, jumper"
          hide-on-single-page
          :total="dataTotal"
        ></el-pagination>
      </el-dialog>
      <!-- 水量复核详情（缴费） -->
      <common-dialog
        append-to-body
        v-if="dialogVisible"
        :title="dialogOptions.title"
        :width="dialogOptions.width"
        :height="dialogOptions.height"
        :visible.sync="dialogVisible"
        cover
      >
        <bill-list @cancel="dialogVisible=false" @refresh="handlerRefresh"></bill-list>
      </common-dialog>
      <!-- 业务进度：用水计划申报状态流程模块 -->
      <common-dialog
        append-to-body
        v-if="planstatedialog"
        :visible.sync="planstatedialog"
        title="申报状态流程"
        width="800px"
        cover
      >
        <!-- <declareflow :billData="currentRowData" @successThen="handlerRefresh" @cancel="planstatedialog=false"></declareflow> -->
        <declareFlowChart :planYear="planyearvalue" @refresh="handlerRefresh"></declareFlowChart>
      </common-dialog>

      <!-- 通知公告 -->
      <common-dialog
        append-to-body
        v-if="dialogitem"
        :visible.sync="dialogitem"
        title="通知详情"
        width="800px"
        cover
      >
        <notice-info :recordData="Itemform"></notice-info>
      </common-dialog>
    </div>
    <hd-loading v-if="pageLoading"></hd-loading>
  </div>
</template>

<script>
import {
  A_ADD_QueryDictListByCode, // 业务状态
  A_ADD_WorkManageplan, // 查询业务进度
  A_PUNO_QueryNoticeList, // 查询通知列表
  A_UWPL_PageQuery, // 申报状态年份查询
  A_PUL_QueryBusinessWaterByyear, // 通过计划户和年份查询营业水量列表
  A_WBDT_QueryBillList, // 查询收费记录数据
  A_PUNO_TagRead // 标记通知为已读
} from '@/assets/js/axiosPresets'
import declareflow from "@/components/Reviewflowchart/index.vue" // 缴费申报流程
import declareFlowChart from "@/components/declareflowchart/index.vue" // 用水计划申报流程
import noticeInfo from '@/components/messageForm/noticeInfo.vue'
import billList from '@/components/recordListTable/billList.vue' // 代缴费列表
import FileSaver from "file-saver"
import {
  F_getOptionLabel
} from '@/assets/js/publicFunSet.js'
export default {
  name: 'homePage',
  components: {
    declareflow,
    declareFlowChart,
    noticeInfo,
    billList
  },
  data () {
    return {
      pageLoading: false,
      userInfo: {
        oid: "",
        code: '--', // 单位编码
        name: '--', // 单位名称
        contact_man: '--', // 联系人
        contact_phone: '--', // 联系电话
        addr_detail: '--', // 详细地址
        postal_code: '--', // 邮政编码
        is_mainuser: 0, // 是否为重点户
        usewater_id: 1, // 用水性质
        usewater_price: '--', // 用水单价
        green_area: '--' // 绿化面积
      },
      WorkState: [], // 业务状态
      dialogname: "", // 名称(做判断)
      dialogtitle: "", // 弹框标题
      dialigwidth: "", // 弹框长度
      dialog: false, // 是否显示弹框
      WorkType: [], // 业务类型数据集合
      Work_States: [], // 业务状态数据集合
      WorkState_u: [], // 业务状态数据集合(未完成)
      formData: {
        worktypes: '', // 业务类型
        workstates: '' // 业务状态(必须)
      }, // 表单数据集合
      formDataRules: { workstates: [{ required: true, message: "请选择业务状态", trigger: "change" }] },
      dialogitem: false, // 通知
      noticeList: [], // 当前通知数据集合
      Itemform: {}, // 通知
      planstatedialog: false, // 用水计划申报状态显示和隐藏(申报)
      planyearvalue: "", // 计划年份(申报)
      planStatusTip: "", // 首页用水计划状态描述
      billTableList: [], // 缴费数据集合
      review_detail: false, // 缴费详情
      review_formitem: false, // 缴费复核
      review_Curve: {}, // 当前缴费数据集合
      echartJson: {}, // echart 对象集合
      chartYear: new Date(), // 当前年份数据
      aggregateYear: {}, // 当前年份的上下半年总计
      tableData: [], // 表格数据集合
      curtableData: [], // 当前table 缓数据
      currentPage: 1, // 当前页数
      dataTotal: 0, // 数据总条数
      // currentRowData: {},
      dictKeyList: [
        'NoticeType',
        'NoticeImportance'
      ],
      pageData: [], // table分页数据
      dialogOptions: {
        title: '',
        width: '600px',
        height: ''
      }, // 弹框样式
      dialogVisible: false // 是否显示弹框
    }
  },
  filters: {
    filterValue (v, t) {
      let r = '--'
      if (v != null && v !== undefined) {
        if (t === 'mainuser') {
          // 是否为重点户
          r = v > 0 ? '是' : '否'
        } else {
          r = v
        }
      }
      return r
    }
  },
  computed: {
    // 用户信息
    basicsUser () {
      return this.$store.state.userInfo || {}
    },
    // 模版数据
    templateDataNotice () {
      return [
        { id: '1', title: '系统操作说明书', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/' },
        // { id: '2', title: '佛山市顺德区住房城乡建设和水利局关于2021年度非居民用水计划管理工作的通知', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/' },
        // { id: '3', title: '温馨提示', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/' },
        // { id: '4', title: '网上办理流程指南图 ', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/' },
        // { id: '5', title: '窗口办理流程指南图 ', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/' },
        { id: '6', title: '佛山市顺德区住房城乡建设和水利局佛山市顺德区发展和改革局佛山市顺德区财政局关于贯彻执行非居民用水实行计划用水管理和累进加价收费的通知', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/' },
        { id: '7', title: '佛山市人民政府办公室关于印发佛山市非居民用水累进加价实施方案的通知', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/' },
        { id: '8', title: '附件1[2022年度顺德区纳入计划用水管理非居民用水户名录（含六万立方米以上及高耗水用水户)]', dec: '点击下载', type: '.xlsx', file: 'FILEEXCEL/通知文件/2022/' },
        { id: '9', title: '附件2（业务办理指南）', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/2022/' },
        { id: '10', title: '佛山市顺德区住房城乡建设和水利局关于2022年度非居民用水计划管理工作的通知', dec: '点击下载', type: '.pdf', file: 'FILEEXCEL/通知文件/2022/' }
      ]
    },
    // 模版数据
    templateData () {
      return [
        { id: '1', title: '（附件1）佛山市非居民用水计划申请表', dec: '点击下载' },
        { id: '2', title: '（附件2）佛山市非居民用水计划调整申请表', dec: '点击下载' },
        { id: '3', title: '（附件4）佛山市非居民用水计划水量复核申请表', dec: '点击下载' },
        { id: '4', title: '（附件5）佛山市非居民用水超计划（超定额）水量复核申请表', dec: '点击下载' }
      ]
    },
    // 分页：单页数据量
    pageSize () {
      return 50
    },
    // 年份
    yearvalue () {
      return this.$store.state.yearvalue
    },
    dictLabelValues () {
      return this.$store.state.dictLabelValues
    }
  },
  watch: {
    // 监听用户信息
    basicsUser (v) {
      // console.log(this.templateData(), 'templateData')
      this.userInfo = this.$initUserInfo()
      this.$get_workschedule()
      this.getNoticeList()
      this.get_querydeclareData()
      this.$queryWatercharge()
      this.$initechars()
      this.handleCreatEchart()
    },
    // 监听分页(解决初始页面数据)
    pageData (v) {
      this.handleCurrentPageData()
    },
    yearvalue (val) {
      this.planyearvalue = val
    }
  },
  async mounted () {
    await this.$initReload()
    if (this.userInfo.oid) {
      this.$get_workschedule()
      this.getNoticeList()
      this.get_querydeclareData()
      this.$queryWatercharge()
      this.$initechars()
      this.handleCreatEchart()
    }
  },
  methods: {
    // 传值: 是否关闭弹框
    updateCity (t) {
      this.planstatedialog = t
    },
    stausItem (i) {
      this.gethandlestatu(i)
    },
    updateinform (e) {
      this.dialogitem = e
    },
    updateAdjust (d) {
      this.review_formitem = d
    },
    updatereviewdetail (g) {
      this.review_detail = g
    },
    // 格式化时间
    $filterTime (val, type) {
      let time = "--"
      if (val) {
        const timestamp = new Date(val)
        const year = timestamp.getFullYear()
        let month = timestamp.getMonth() + 1
        month = month < 10 ? "0" + month : month
        let day = timestamp.getDate()
        day = day < 10 ? "0" + day : day
        let hour = timestamp.getHours()
        hour = hour < 10 ? "0" + hour : hour
        let minutes = timestamp.getMinutes()
        minutes = minutes < 10 ? "0" + minutes : minutes
        switch (type) {
          case "yyyy-MM-dd hh:mm":
            time =
              year.toString() + "-" + month.toString() + "-" + day.toString() + ' ' + hour.toString() + ":" + minutes.toString()
            break
          case "yyyy-MM":
            time =
              year.toString() + "年" + month.toString() + "月"
            break
          case "YYYY-MM":
            time =
              year.toString() + "-" + month.toString()
            break
          case "hh:mm":
            time = hour.toString() + ":" + minutes.toString()
            break
          case "yyyy":
            time = year.toString()
            break
          case "MM":
            time = month.toString() + "月"
            break
        }
      }
      return time
    },
    // 初始化：页面加载当前用户信息
    async $initReload () {
      if (this.$store.state.ifrefresh) {
        this.userInfo = this.$store.state.userInfo
      }
      this.pageLoading = true
      await this.$store.dispatch('getDictLabelValues', this.dictKeyList)
      this.pageLoading = false
    },
    // 初始化：获取基本信息
    $initUserInfo () {
      if (this.$store.state.userInfo) {
        return this.$store.state.userInfo
      }
    },
    // 初始化：获取初始图表数据
    $initechars () {
      this.$querynewYearWater(parseInt(this.$filterTime(this.chartYear, 'yyyy')))
    },
    // 数据：获取业务通知数据
    async getNoticeList () {
      const _res = await this.$F_checkAxiosIn(A_PUNO_QueryNoticeList({
        user_id: this.userInfo.oid,
        is_read: 0
      }))
      if (!_res) {
        return
      }
      const _list = _res.data.Content
      _list.forEach(_row => {
        _row.create_time = new Date(_row.create_time).format('yyyy/MM/dd hh:mm')
        _row.is_read_text = F_getOptionLabel(this.dictLabelValues.CommonBoolean || [], _row.is_read)
        _row.notice_type_text = F_getOptionLabel(this.dictLabelValues.NoticeType || [], _row.notice_type)
        _row.importance_text = F_getOptionLabel(this.dictLabelValues.NoticeImportance || [], _row.importance)
      })
      _list.sort((a, b) => new Date(b.create_time) - new Date(a.create_time))
      this.noticeList = _list
    },
    // 数据：获取业务进度/业务状态
    async $get_workschedule () {
      const _list = []
      let sid = []
      const wid = await A_ADD_QueryDictListByCode(["WorkProgressState", "WorkProgressType"])
      wid.data.Content.filter(e => {
        switch (e.code) {
          case 'WorkProgressType':
            this.WorkType = e.dict_detail
            break
          case 'WorkProgressState':
            e.dict_detail.filter(t => {
              if (t.code !== '4' && t.code !== '-1') {
                _list.push(t)
              }
            })
            sid = _list
            this.WorkState_u = _list
            this.Work_States = _list
            break
        }
      })
      const cid = await A_ADD_WorkManageplan({ user_id: this.userInfo.oid, work_type: "", work_status: "" })
      const returnData = JSON.parse(JSON.parse(cid.data.d).resultMaps)
      returnData.filter(r => {
        r.user_code = this.userInfo.code
        r.user_name = this.userInfo.name
      })
      this.curtableData = returnData
      sid.forEach((e, index) => {
        const data = returnData.filter(d => {
          return d.work_status === e.code
        })
        e.num = data.length
        e.color = 'v' + (index + 1)
      })
      this.WorkState = sid
    },
    // 数据：获取申报状态年份查询
    async get_querydeclareData () {
      const wid = await A_UWPL_PageQuery({ user_id: this.userInfo.oid, is_on_process: 1, pageIndex: 1, pageSize: 50, sortField: "plan_year", sortOrder: 'desc' })
      // console.log(wid, 'wid')
      if (wid.data.Content.list.length !== 0) {
        this.planyearvalue = this.$filterTime(wid.data.Content.list[0].plan_year + '', 'yyyy')
        // this.currentRowData = wid.data.Content.list[0]
        this.gethandlestatu(wid.data.Content.list[0].process_status)
      } else {
        this.planyearvalue = this.$filterTime(new Date(), 'yyyy')
        this.planStatusTip = `${this.planyearvalue}年用水计划还未核定`
      }
    },
    // 数据：查询收费状态
    async $queryWatercharge () {
      const data = {
        audit_status: "",
        charge_status: "1",
        sort_field: "",
        sort_order: "",
        user_id: this.userInfo.oid
      }
      const wid = await A_WBDT_QueryBillList(data)
      if (wid.data.Content) {
        const _json = []
        wid.data.Content.filter(e => {
          if (e.process_status !== '6') {
            e.user_name = this.userInfo.name
            e.user_code = this.userInfo.code
            e.s_time = this.$filterTime(e.s_date, 'yyyy-MM')
            e.e_time = this.$filterTime(e.e_date, 'yyyy-MM')
            _json.push(e)
          }
        })
        this.billTableList = _json
      }
    },
    // 数据：获取今年用水量数据信息(图表数据)
    async $querynewYearWater (e) {
      let sumData
      let stateData
      [sumData, stateData] = await Promise.all([
        A_PUL_QueryBusinessWaterByyear({ s_year: e, e_year: e, user_id: this.userInfo.oid }),
        A_UWPL_PageQuery({ user_id: this.userInfo.oid, plan_year: e, is_on_process: 1, pageIndex: 1, pageSize: 50 })
      ])

      // console.log(sumData)
      // 汇总水量数据
      const waterlist = sumData.data.Content.water_list
      const resultdata = { xAxisdata: [], watervalue: [], planvalue: [], average: [] }
      // const _aggregateYear = { water_first: 0, plan_first: 0, average_first: 0, water_second: 0, plan_second: 0, average_second: 0 }
      const _aggregateYear = { water_first: 0, plan_first: 0, average_first: 0, water_second: 0, plan_second: 0, average_second: 0, water_third: 0, plan_third: 0, average_third: 0, water_four: 0, plan_four: 0, average_four: 0 }
      // 汇总用水量
      const waterResult = {}
      if (waterlist) {
        waterlist.forEach((item, indx) => {
          const mDate = new Date(item.record_date)
          const mKey = mDate.format('yyyy-MM')
          if (waterResult[mKey]) {
            waterResult[mKey] += item.usewater
          } else {
            waterResult[mKey] = item.usewater
          }
          if (mDate.getMonth() < 3) {
            _aggregateYear.water_first += item.usewater
          } else if (mDate.getMonth() < 6 && mDate.getMonth() >=3) {
            _aggregateYear.water_second += item.usewater
          } else if (mDate.getMonth() < 9 && mDate.getMonth() >=6) {
            _aggregateYear.water_third += item.usewater
          } else {
            _aggregateYear.water_four += item.usewater
          }
        })
      }
      // 汇总计划水量
      const list = stateData.data.Content.list
      if (list[0] && list[0].usewater_plan_detail) {
        list[0].usewater_plan_detail.forEach((it, index) => {
          resultdata.planvalue.push(it.plan_val)
          if (index <= 2) {
            _aggregateYear.plan_first += it.plan_val
          } else if (index <= 5 && index > 2) {
            _aggregateYear.plan_second += it.plan_val
          } else if (index <= 8 && index > 5) {
            _aggregateYear.plan_third += it.plan_val
          } else {
            _aggregateYear.plan_four += it.plan_val
          }
        })
      }

      console.log(resultdata)
      Array(12).fill(1).forEach((item, index) => {
        const month = e + '-' + (index + 1) + '-' + 1
        const mKey = new Date().parseDate(month).format('yyyy-MM')
        resultdata.xAxisdata[index] = mKey
        resultdata.watervalue[index] = waterResult[mKey] || null
      })

      if (_aggregateYear.plan_first === 0 || _aggregateYear.water_first === 0) {
        _aggregateYear.average_first = '--'
      } else {
        _aggregateYear.average_first = (_aggregateYear.water_first / _aggregateYear.plan_first * 100).toFixed(2)
      }

      if (_aggregateYear.plan_second === 0 || _aggregateYear.water_second === 0) {
        _aggregateYear.average_second = '--'
      } else {
        _aggregateYear.average_second = (_aggregateYear.water_second / _aggregateYear.plan_second * 100).toFixed(2)
      }

      if (_aggregateYear.plan_third === 0 || _aggregateYear.water_third === 0) {
        _aggregateYear.average_third = '--'
      } else {
        _aggregateYear.average_third = (_aggregateYear.water_third / _aggregateYear.plan_third * 100).toFixed(2)
      }

      if (_aggregateYear.plan_four === 0 || _aggregateYear.water_four === 0) {
        _aggregateYear.average_four = '--'
      } else {
        _aggregateYear.average_four = (_aggregateYear.water_four / _aggregateYear.plan_four * 100).toFixed(2)
      }

      this.aggregateYear = _aggregateYear
      this.$barchart('aggregateYearFlow', ['#5793f3', '#d14a61', '#084756'], ['计划量', '用水量', '用水占比'], resultdata)
    },
    getRateColor (rate) {
      rate = Number(rate) || 0
      if (rate < 40) {
        return '#67c23a'
      } else if (rate < 80) {
        return '#e6a23c'
      } else {
        return 'red'
      }
    },
    // 图表：初始化创建echart
    handleCreatEchart () {
      // 监听屏幕状态
      window.onresize = e => {
        this.handleEchartsResize()
      }
      if (window.addEventListener) {
        document.addEventListener("fullscreenchange", () => {
          this.handleEchartsResize()
        })
        document.addEventListener("webkitfullscreenchange", () => {
          this.handleEchartsResize()
        })
        document.addEventListener("mozfullscreenchange", () => {
          this.handleEchartsResize()
        })
        document.addEventListener("MSFullscreenChange", () => {
          this.handleEchartsResize()
        })
      }
    },
    // 功能：重新渲染图表
    handleEchartsResize () {
      Object.values(this.echartJson).map(item => {
        item.resize()
      })
    },
    // 图表: 加载图表
    $barchart (id, colors, legend, data) {
      const option = {
        color: colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: { saveAsImage: { show: true } }
        },
        legend: { legend },
        xAxis: [
          {
            type: 'category',
            axisPointer: { type: 'shadow' },
            data: data.xAxisdata
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '水量(m³)',
            axisLine: {
              lineStyle: { color: colors[1] }
            },
            axisLabel: { formatter: '{value}' }
          },
          {
            type: 'value',
            name: '占比(%)',
            axisLine: {
              lineStyle: { color: colors[2] }
            },
            axisLabel: { formatter: '{value}' }
          }
        ],
        series: [
          {
            name: '计划量',
            type: 'bar',
            barGap: 0,
            data: data.planvalue
          },
          {
            name: '用水量',
            type: 'bar',
            data: data.watervalue
          },
          {
            name: '用水占比',
            type: 'line',
            yAxisIndex: 1,
            data: data.average
          }
        ]
      }
      let myChart = ""
      if (!this.echartJson[id]) {
        myChart = this.$echarts.init(document.getElementById(id))
        this.$set(this.echartJson, id, myChart)
      } else {
        this.echartJson[id].resize()
      }
      this.echartJson[id].setOption(option)
    },
    // 数据：处理当前状态
    gethandlestatu (e) {
      switch (e) {
        case '1':
          this.planStatusTip = `${this.planyearvalue}年用水计划还未核定`
          break
        case '101':
          this.planStatusTip = `${this.planyearvalue}年用水计划水表信息行政部门变更中`
          break
        case '102':
          this.planStatusTip = `${this.planyearvalue}年用水计划水表信息行政部门已变更`
          break
        case '201':
          this.planStatusTip = `${this.planyearvalue}年用水计划申请已提交，请上传申请文件`
          break
        case '2':
          this.planStatusTip = `${this.planyearvalue}年用水计划已申报审核中`
          break
        case '3':
          this.planStatusTip = `${this.planyearvalue}年用水计划申报后已审核`
          break
        case '401':
          this.planStatusTip = `${this.planyearvalue}年用水计划已申请复核，请上传申请文件`
          break
        case '4':
          this.planStatusTip = `${this.planyearvalue}年用水计划行政部门复核中`
          break
        case '6':
          this.planStatusTip = `${this.planyearvalue}年用水计划已核定完成`
          break
        default:
          this.planStatusTip = ''
          break
      }
    },
    // 数据：获取业务进度
    handleworkschedule (t) {
      const _list = []
      this.curtableData.filter(e => {
        if (e.work_status === t) {
          _list.push(e)
        }
      })
      this.handleCreateDataPage(_list)
      this.tableData = _list
    },
    // 数据：点击用水计划申报状态赋值(用水计划申报)
    handleplanstates () {
      // console.log(this.planyearvalue, 'planyearvalueplanyearvalue')
      this.planstatedialog = true
    },
    // 功能：刷新数据
    handlerRefresh () {
      this.billTableList = []
      this.WorkState = []
      this.planstatedialog = false
      this.planStatusTip = "" // 首页用水计划状态描述
      this.$get_workschedule()
      this.$queryWatercharge()
      this.get_querydeclareData()
    },
    // 功能：点击进度事件(点击球)
    handlecell (t) {
      this.handleworkschedule(t.code)
      this.formData.workstates = t.code
      this.dialogtitle = '业务进度列表'
      this.dialigwidth = "1400px"
      this.dialog = true
    },
    // 功能：点击当前通知详情内容
    hanleNoticeRowClick (d, index) {
      if (d.is_read === 0) {
        A_PUNO_TagRead(d.oid)
        this.noticeList.splice(index, 1)
      }
      this.Itemform = d
      this.dialogitem = true
    },
    // 功能：公用操作按钮点击
    handleHomeToolClick (e) {
      this.dialogname = e
      switch (e) {
        case 'overPlanManage':
          this.dialogOptions.width = '1000px'
          this.dialogOptions.title = "待缴费记录列表"
          break
      }
      this.dialogVisible = true
    },
    // 功能：重置数据
    handlecancel () {
      this.dialog = false
      this.dialogitem = false
      this.tableData = []
      this.formData = {
        worktypes: '', // 业务类型
        workstates: '' // 业务状态(必须)
      }
    },
    // 功能：选择年份(图表)
    handleYear () {
      this.$querynewYearWater(parseInt(this.$filterTime(this.chartYear, 'yyyy')))
    },
    // 功能：筛选条件
    onsearch () {
      const _wT = this.formData.worktypes
      const _wS = this.formData.workstates
      const _data = this.curtableData
      const _tableData = []
      if (_wT) {
        _data.filter(e => {
          if (e.work_status === _wS && e.work_type === _wT) {
            _tableData.push(e)
          }
        })
      } else {
        _data.filter(e => {
          if (e.work_status === _wS) {
            _tableData.push(e)
          }
        })
      }
      this.handleCreateDataPage(_tableData)
    },
    // 功能：筛选后的数据分页
    handleCreateDataPage (data) {
      const _pageData = []
      let _page = []
      let n = 0
      data.forEach(item => {
        _page.push(item)
        n++
        if (n % this.pageSize === 0 || n === data.length) {
          _pageData.push(_page)
          _page = []
        }
      })
      this.dataTotal = data.length
      this.pageData = _pageData
    },
    // 功能：设置当前分页数据
    handleCurrentPageData () {
      this.tableData = this.pageData[this.currentPage - 1]
    },
    // 功能：分页(当前页数)
    handleCurrentChange (val) {
      this.currentPage = Number(`${val}`)
      this.handleCurrentPageData()
    },
    // 功能：表格业务类型操作事件
    handlebtns (row) {
      let _path = ''
      switch (row.work_type) {
        case "201":
        case "202":
        case "203":
        case "205":
        case "206":
          _path = 'basicsManage'
          break
        case "301":
        case "302":
        case "303":
        case "304":
          _path = 'waterPlanManage'
          break
        case "204":
          _path = 'meterManage'
          break
        case "401":
        case "402":
          _path = 'overPlanManage'
          break
      }
      this.$router.push({ path: _path })
    },
    async downloadNoticeFile (e) {
      await this.$confirm('确认下载？')
      try {
        FileSaver.saveAs(`/fsjs/${e.file}${e.title}${e.type}`, `${e.title}${e.type}`)
      } catch (error) {
        this.$message.error('下载失败！')
        console.log(error)
      }
    },
    // 功能：下载按钮事件
    async downloadhandle (e) {
      await this.$confirm('确认下载？')
      try {
        FileSaver.saveAs(`/fsjs/FILEEXCEL/业务模板文件/${e}.docx`, `${e}.docx`)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-main {
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .inline-block {
    display: inline-block;
    vertical-align: middle;
  }

  .home-body {
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    padding-right: 15px;
    height: calc(100% - 15px);
    // overflow: auto;

    .item-box {
      margin-left: 15px;
      margin-top: 15px;
      width: calc(50% - 17px);
      height: calc(68% - 17px);
      box-shadow: 0 0 5px 2px #e2e2e2;
      border: 1px solid #ddd;
      border-radius: 10px;
      background-color: #fff;

      .model-title {
        overflow: hidden;
        padding: 10px 20px 5px;
        margin-bottom: 10px;
        position: relative;
        color: #393e46;

        &::after {
          content: '';
          position: absolute;
          background: linear-gradient(125deg, #18cef2 0%, #448aff 100%);
          left: 13px;
          width: 90px;
          height: 3px;
          bottom: 0px;
          -webkit-transition: 0.5s;
          -moz-transition: 0.5s;
          -ms-transition: 0.5s;
          -o-transition: 0.5s;
          transition: 0.5s;
        }

        .txt {
          font-size: 14px;
          letter-spacing: 5px;
          font-weight: 400;
        }

        .link {
          float: right;

          &:hover {
            color: #2393b1;
          }
        }

        .handle {
          float: right;

          .btn {
            margin-right: 15px;
            cursor: pointer;

            &:hover {
              color: #2393b1;

              .ico {
                transform: -webkit-rotate(360deg);
                transform: -moz-rotate(360deg);
                transform: -ms-rotate(360deg);
                transform: -o-rotate(360deg);
                transform: rotate(360deg);
              }
            }

            .ico {
              margin-left: 3px;
              transition: all 0.3s;
            }
          }
        }
      }

      .model-content {
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0 3% 10px;
        height: calc(100% - 56px);

        .item-row {
          padding: 8px 0;
          font-size: 14px;

          &.flex {
            display: -webkit-flex;
            display: flex;
          }

          .item-cell {
            flex: 1;
          }

          .cell-title {
            width: 100px;
            color: #8e8e8e;
          }

          &.pos {
            position: relative;
            padding-right: 120px;
            overflow: hidden;
            border-bottom: 1px dashed #ddd;

            .ico {
              margin-right: 10px;
              font-size: 14px;
              color: #339fb7;
            }
          }

          .val {
            position: absolute;
            top: 50%;
            right: 0;
            transform: -webkit-translateY(-50%);
            transform: -moz-translateY(-50%);
            transform: -ms-translateY(-50%);
            transform: -o-translateY(-50%);
            transform: translateY(-50%);
            font-size: 12px;
            color: #8e8e8e;
          }

          .download {
            cursor: pointer;
            color: #3187b1;

            &:hover {
              &::after {
                left: 0;
                right: 0;
              }
            }

            &::after {
              content: '';
              position: absolute;
              bottom: -3px;
              left: 50%;
              right: 50%;
              height: 2px;
              background: linear-gradient(125deg, #18cef2 0%, #448aff 100%);
              transition: all 0.3s;
            }
          }
        }

        .circle-item {
          height: 100%;
          > p {
            font-size: 18px;
            font-weight: 700;
            padding: 5px 18px;
            > span {
              color: #70b603;
              font-weight: 700;
            }
            > i {
              font-weight: 700;
              color: #e23b50;
              font-style: normal;
            }
          }
          .circle-view {
            flex-wrap: wrap;
            display: -webkit-flex;
            display: flex;
            white-space: nowrap;
            align-items: center;
            justify-content: center;
            // height: 100%;
            height: calc(100% - 102px);

            .circle-cell {
              padding: 3% 0;
              margin: 0 8%;

              .circle {
                width: 80px;
                height: 80px;
                line-height: 80px;
                border-radius: 50%;
                color: #fff;
                text-align: center;
                font-size: 23px;

                &.v1 {
                  box-shadow: 0 0 5px 5px #f5dab1;
                  background-color: #fdf6ec;
                  color: #e6a23c;
                }
                &.v2 {
                  box-shadow: 0 0 5px 5px #b3d8ff;
                  background-color: #ecf5ff;
                  color: #409eff;
                }
                &.v3 {
                  box-shadow: 0 0 5px 5px #c2e7b0;
                  background-color: #f0f9eb;
                  color: #67c23a;
                }
                &.v4 {
                  box-shadow: 0 0 5px 5px #f7ed6b;
                  background-color: #faf8da;
                  color: #ffce35;
                }
                &.v5 {
                  box-shadow: 0 0 5px 5px #df6161;
                  background-color: #f8cace;
                  color: #ff0033;
                }
              }

              .txt {
                padding-top: 20px;
                text-align: center;
                font-size: 18px;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
    .item-box-out {
      width: calc(50% - 17px);
      margin-left: 15px;
      margin-top: 15px;
      height: calc(68% - 17px);
      .item-box {
        width: auto;
        margin-left: 0;
        height: 43%;
        &:nth-of-type(1) {
          margin-top: 0;
          height: 54%;
        }
      }
    }
    .item-boxwidth {
      width: calc(100% - 17px);
    }
    .item-boxheight {
      height: calc(32.5% - 17px);
    }
  }
  .temporarily-data {
    height: 100%;
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
  }
  .btn-marleft {
    margin-left: 20px;
  }
  .chart-title {
    width: 100%;
    height: 100%;
    > p {
      padding: 5px;
      font-size: 16px;
      font-weight: 700;
      .chart-picker {
        width: 25%;
      }
      > span {
        font-weight: 700;
        padding-right: 50px;
      }
    }
    .title-text {
      width: 100%;
      height: 100%;
      > p {
        display: flex;
        font-size: 14px;
        font-weight: 700;
        padding: 5px;
        > .item-title {
          line-height: 24px;
          font-weight: 700;
          font-size: 16px;
        }
        > .item-text {
          line-height: 24px;
          flex: 1;
          > i {
            font-weight: 700;
            font-size: 16px;
            font-style: normal;
          }
        }
        > .item-plan {
          > i {
            color: #5793f3;
          }
        }
        > .item-use {
          > i {
            color: red;
          }
        }
      }
    }
  }
  .chart-body {
    width: 100%;
    height: 376px;
  }
}
</style>